var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('master-management-panel',{on:{"handleAction":_vm.onAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }